import React from "react";
import * as Mui from "@material-ui/core";
import { useField } from "formik";
import { IconChevronDown } from "../svg";
import Skeleton from "react-loading-skeleton";

const GroupSelectField = ({
  label,
  classes = {},
  options,
  optionLabel,
  variant,
  shrinkLabel = true,
  loading = false,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const [val, setVal] = React.useState("");

  const handleChange = (event) => {
    setVal(event.target.value);
    helpers.setValue(event.target.value);
  };

  const renderSelectGroup = (data) => {
    const items = data?.children?.map((item, i) => {
      return (
        <Mui.MenuItem
          key={item.id}
          value={item.id}
          data-cy={`option-menu-${i}`}
        >
          {item.name}
        </Mui.MenuItem>
      );
    });
    return [
      <Mui.ListSubheader style={{ pointerEvents: "none" }}>
        {data.name}
      </Mui.ListSubheader>,
      items,
    ];
  };

  return (
    <Mui.FormControl
      error={meta.touched && meta.error ? true : false}
      variant={variant ? variant : "outlined"}
    >
      <Mui.InputLabel shrink={shrinkLabel} htmlFor="grouped-select">
        {label}
      </Mui.InputLabel>
      {loading ? <Skeleton height={40} /> :
      <Mui.Select
        id="grouped-select"
        value={val}
        data-cy="group-select-field"
        onChange={handleChange}
        {...field}
        {...props}
        IconComponent={IconChevronDown}
        MenuProps={{
          className: "select-dropdown",
          getContentAnchorEl: null,

          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "center",
          },
          classes: classes,
        }}
      >
        {options?.map((item) => renderSelectGroup(item))}
      </Mui.Select>
      }
      {meta.touched && meta.error ? (
        <Mui.FormHelperText error>
          {meta.touched && meta.error ? meta.error : null}
        </Mui.FormHelperText>
      ) : null}
    </Mui.FormControl>
  );
};

export default GroupSelectField;
